import APIService from 'services/APIService'
import qs from 'qs'

const api = APIService()

export const getEstateFiles = ({ estateId, query, buildingPassportId }, signal) => {
  let queryValues = { page: 1, limit: 3000 }

  if (query) {
    queryValues = { ...queryValues, ...query }
  }

  if (buildingPassportId) {
    queryValues = { ...queryValues, 'filter[building_passport_id]': buildingPassportId }
  }

  const queryString = qs.stringify(queryValues, { addQueryPrefix: true })
  return api.get(`/estates/${estateId}/files${queryString}`, signal ? { signal } : {})
}

export const getEstateFileCounts = ({ estateId, query, buildingPassportId }) => {
  let queryValues = query ? { ...query } : {}

  if (buildingPassportId) {
    queryValues = { ...queryValues, 'filter[building_passport_id]': buildingPassportId }
  }

  const queryString = Object.keys(queryValues).length > 0
    ? qs.stringify(queryValues, { addQueryPrefix: true })
    : ''

  return api.get(`/estates/${estateId}/files/counts${queryString}`)
}

export const searchEstateFiles = (payload, signal) => {
  const { estateId, query, uploaderIds, fileTypeIds, fileCategoryIds, fileTagIds } = payload

  const params = {
    query: query || ''
  }

  if (uploaderIds?.length > 0) {
    params.uploader_ids = uploaderIds
  }

  if (fileTypeIds?.length > 0) {
    params.file_type_ids = fileTypeIds
  }

  if (fileCategoryIds?.length > 0) {
    params.file_category_ids = fileCategoryIds
  }

  if (fileTagIds?.length > 0) {
    params.file_tag_ids = fileTagIds
  }

  const queryString = qs.stringify(params, {
    arrayFormat: 'brackets',
    skipNulls: true
  })

  return api.get(`/estates/${estateId}/search-file?${queryString}`, signal ? { signal } : {})
}

export const getEstateOwnedFiles = ({ estateId, page = 1, limit = 30, folderId }) => {
  let queryValues = { page, limit }

  if (folderId) {
    queryValues = { ...queryValues, 'filter[folder_id]': folderId }
  }

  const queryString = qs.stringify(queryValues, { addQueryPrefix: true })
  return api.get(`/estates/${estateId}/documents/files${queryString}`)
}

export const generateEstateUploadUrl = ({ estateId, displayName, ...rest }) => {
  return api.post(`/estates/${estateId}/documents/upload-url`, { displayName, ...rest })
}

export const uploadEstateFile = ({ estateId, files }) => {
  return api.post(`/estates/${estateId}/documents/files`, { files })
}

export const getEstateFileUrls = ({ estateId, fileId }) => {
  return api.get(`/estates/${estateId}/documents/files/${fileId}/urls`)
}

export const updateEstateFile = ({ estateId, fileId, displayName, description, fileTypeId }) => {
  const body = {}
  if (displayName !== undefined) body.displayName = displayName
  if (description !== undefined) body.description = description
  if (fileTypeId !== undefined) body.fileTypeId = fileTypeId
  return api.patch(`/estates/${estateId}/documents/files/${fileId}`, body)
}

export const deleteEstateFile = ({ estateId, fileId }) => {
  return api.delete(`/estates/${estateId}/documents/files/${fileId}`)
}

export const getEstateFolders = ({ estateId }) => {
  return api.get(`/estates/${estateId}/documents/folders`)
}

export const createEstateFolder = ({ estateId, name, parentFolderId }) => {
  return api.post(`/estates/${estateId}/documents/folders`, { name, parentFolderId })
}

export const updateEstateFolder = ({ estateId, folderId, name, parentFolderId }) => {
  return api.patch(`/estates/${estateId}/documents/folders/${folderId}`, { name, parentFolderId })
}

export const deleteEstateFolder = ({ estateId, folderId }) => {
  return api.delete(`/estates/${estateId}/documents/folders/${folderId}`)
}

export const assignEstateFileToFolder = ({ estateId, folderId, fileId }) => {
  return api.post(`/estates/${estateId}/documents/folders/${folderId}/files`, { fileId })
}

export const unassignEstateFileFromFolder = ({ estateId, folderId, fileId }) => {
  return api.delete(`/estates/${estateId}/documents/folders/${folderId}/files/${fileId}`)
}

export const shareEstateFile = ({ estateId, fileId, email, accessLevel, expiresAt }) => {
  return api.post(`/estates/${estateId}/documents/files/${fileId}/share`, { email, accessLevel, expiresAt })
}

export const listEstateFileSharedUsers = ({ estateId, fileId }) => {
  return api.get(`/estates/${estateId}/documents/files/${fileId}/shared-users`)
}

export const revokeEstateFileExternalShare = ({ estateId, fileId, shareId }) => {
  return api.delete(`/estates/${estateId}/documents/files/${fileId}/external-share/${shareId}`)
}

export const shareEstateFileWithBuildingPassports = ({ estateId, fileId, buildingPassportIds }) => {
  return api.post(`/estates/${estateId}/documents/files/${fileId}/share-to-bps`, { buildingPassportIds })
}

export const listEstateFileBuildingShares = ({ estateId, fileId }) => {
  return api.get(`/estates/${estateId}/documents/files/${fileId}/bp-shares`)
}

export const removeEstateFileBuildingShare = ({ estateId, fileId, shareId }) => {
  return api.delete(`/estates/${estateId}/documents/files/${fileId}/bp-shares/${shareId}`)
}

export const bulkShareEstateFilesToBps = ({ estateId, fileIds, buildingPassportIds }) => {
  return api.post(`/estates/${estateId}/documents/files/bulk-share-to-bps`, { fileIds, buildingPassportIds })
}

export const toggleEstateFolderAccess = ({ estateId, userId, folders }) => {
  return api.patch(`/estates/${estateId}/documents/folders/access`, { userId, folders })
}

export const getEstateFolderUserCounts = ({ estateId }) => {
  return api.get(`/estates/${estateId}/documents/folders/user-counts`)
}

export const getEstateFolderUsers = ({ estateId, folderId }) => {
  return api.get(`/estates/${estateId}/documents/folders/${folderId}/users`)
}
